import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      marginLeft: spacing.xxl,
    },
    accountContainer: {
      display: "inline-flex",
      flexDirection: "row",
      backgroundColor: theme.card.background,
      alignSelf: "flex-start",
      padding: `${spacing.s}px ${spacing.m}px`,
      borderRadius: constants.radius.button,
      alignItems: "center",
      justifyContent: "center",
    },
    text: {
      marginLeft: spacing.xs,
    },
    copyContainer: {
      padding: `${spacing.s}px ${spacing.m}px`,
      marginLeft: spacing.xs,
      border: `1px solid ${theme.border}`,
      borderRadius: constants.radius.button,
      cursor: "pointer",
      userSelect: "none",
    },
  };

  return styles;
};
